export const resourceStatus = {
  'Draft': 0,
  'Publish': 1,
  'Inactive': 2
}

export const resourceStatusUpdateMapping = {
  0: ['Publish', 'Inactive'],
  1: ['Inactive'],
  2: ['Draft']
}

export const resourceStatusClassMapping = {
  'Draft': 'badge badge-pill btn-primary',
  'Publish': 'badge badge-pill btn-success',
  'Inactive': 'badge badge-pill btn-danger'
}

export const currentResourceStatusMapping = {
  0: 'Draft',
  1: 'Published',
  2: 'Inactive'
}

export const resourceButtonTexts = [
  { value: 'shop_now', label: 'Shop Now' },
  { value: 'visit_partner', label: 'Visit Partner' }
]



// WEBPACK FOOTER //
// ./src/components/resources-management/helpers.js